import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import {
  TableLoader,
  TableWithNoData,
} from "../../../../components/snippets/template-blocks";
import {
  ADMIN_PLUS_ICON,
} from "../../../../utils/app-image-contant";
import debounce from "lodash/debounce";
import TableSubHeander from "./TableSubHeander";
import { CSVLink } from "react-csv";


const AdminDataTable = ({
  buttonaLable = "",
  pending = true,
  setPending = function o() { },
  defaultSortColumn = "id",
  _tblColumns = [],
  _rowData = [],
  tableCustomStyles = {},
  _totalRows,
  paginationServer = true,
  isFilter = false,
  title = null,
  isShowAddButton = true,
  showPagination = {},
  handleNew = function o() { },
  setSortDirection = function o() { },
  setSortColumn = function o() { },
  setPageSize = "",
  setPage = "",
  setSearchTerm = function o() { },
  pageSize,
  pagination = true,
  selectableRows = false,
  setSelectedRows = false,
  expandableRowsComponent,
  expandableRows = false,
  selectedData = [],
  setselectedData = function o() { },
  handleBulkDelete = function o() { },
  setIsSearchTriggered = function o() { },
  lableForDelete = "",
  isCSVShowAddButton = false,
  csvheaders = [],
  csvData,
  csvFileName = "",
  paginationResetDefaultPage=false
}) => {
  const [tableColumns, setTableColumns] = useState(_tblColumns);
  const handlePageChange = async (newPerPage) => {
    newPerPage = newPerPage !== 0 ? newPerPage - 1 : newPerPage;
    setIsSearchTriggered(true)
    setPage(newPerPage);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    handlePageChange(page);
    setPageSize(newPerPage);
  };

  const handleSort = async (column, sortDirection) => {

    setSortColumn(column.code);
    setSortDirection(sortDirection);
    handlePageChange(0);
  };
  const handleSelectionChange = ({ selectedRows }) => {
    if (setSelectedRows) {
      setselectedData([...selectedRows]);
      setSelectedRows(selectedRows);
    }
  };

  const onChange = (e) => {
    const { value } = e.target;
    if (value.length === 0) {
      setSearchTerm("");
    } else {
      setSearchTerm(e.target.value);

    }
  };

  const debouncedOnChange = debounce(onChange, 400);

  var currentdate = new Date();
  var datetime = + currentdate.getDate() + "/"
    + (currentdate.getMonth() + 1) + "/"
    + currentdate.getFullYear() + " @ "
    + currentdate.getHours() + ":"
    + currentdate.getMinutes() + ":"
    + currentdate.getSeconds();

  return (
    <>
      <div className="jana_admindatatable_sec">
        <div className="white_card card_height_100 mb_30 user_crm_wrapper  mt-2">
          <div className="row">
            <div className="col-lg-12">
              <div className="single_crm">
                <div className="crm_body  tabledata">
                  {isFilter && (
                    <div className="row d-flex justify-content-center align-items-center">
                      <div className="col-xl-4 col-lg-4 col-md-12 col-12">
                        <h4 className="main-heading-datatable pb-3">{title}</h4>
                      </div>

                      <div className="col-xl-8 col-lg-8 col-md-12 col-12 d-md-flex d-lg-flex d-xl-flex d-block admin-table-right-box">
                        {buttonaLable !== "New Banner" && <div className="search_field mb-3 ms-md-2 ms-lg-2 ms-xl-2 right-search-box">
                          <input
                            onKeyDown={(event) => {
                              const regex = /^[a-zA-Z0-9]*$/;
                              const key = event.key;
                              if (!regex.test(key) && key !== 'Backspace') {
                                event.preventDefault();
                              }
                            }}
                            type="text"
                            className="form-control admin-user-input"
                            placeholder="Search"
                            onChange={debouncedOnChange}
                          />
                        </div>}
                        {isShowAddButton && (<div>

                          <button
                            type="button"
                            className="btn mb-3 btn-primary ms-md-2 ms-lg-2 ms-xl-2 right-plus-button admin-user-input"
                            onClick={handleNew}
                          >
                            <img
                              src={ADMIN_PLUS_ICON}
                              alt="plus-icon"
                              width="10px"
                              className="me-1"
                            />
                            {buttonaLable}
                          </button>

                        </div>)}

                        {isCSVShowAddButton &&
                          <>

                            <CSVLink className="btn float-end ms-2 mb-3 exportcsv " filename={csvFileName + datetime + '.csv'}
                              data={csvData} headers={csvheaders}> <img
                                src={ADMIN_PLUS_ICON}
                                alt="plus-icon"
                                width="10px"
                                className="me-1 plus-button"
                              />Export CSV</CSVLink>
                          </>


                        }
                        {/* <div>
                          <SortByDropdown
                            options={sortOptions}
                            defaultOptions={["id"]}
                            onSort={handleSort}
                          />
                        </div> */}
                      </div>


                    </div>
                  )}
                  <div className="row">
                    <div className="col-12">
                      <DataTable
                        selectableRows={selectableRows}
                        columns={tableColumns}
                        data={_rowData}
                        className="dataTableStyle"
                        responsive={true}
                        customStyles={tableCustomStyles}
                        direction="auto"
                        paginationServer={paginationServer}
                        paginationTotalRows={_totalRows}
                        progressPending={pending}
                        progressComponent={<TableLoader />}
                        pagination={pagination}
                        onSort={handleSort}
                        paginationPerPage={pageSize}
                        noDataComponent={<TableWithNoData setPending={setPending} />}
                        onSelectedRowsChange={handleSelectionChange}
                        onChangeRowsPerPage={handlePerRowsChange}
                        onChangePage={handlePageChange}
                        paginationRowsPerPageOptions={[5, 10, 25, 50, 100]}
                        expandableRows={expandableRows}
                        expandableRowsComponent={expandableRowsComponent}
                        subHeader={selectedData?.length !== 0}
                        subHeaderComponent={<TableSubHeander lableForDelete={lableForDelete} deletedItem={selectedData?.length} handleBulkDelete={handleBulkDelete} />}
                        persistTableHead
                        sortServer={true}
                        paginationResetDefaultPage={paginationResetDefaultPage}
                      ></DataTable>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminDataTable;
